var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperclip28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.457 3.005a6.702 6.702 0 0 1 9.573.01c2.63 2.676 2.626 7.003-.01 9.672l-6.613 6.696a4.125 4.125 0 0 1-5.884 0 4.25 4.25 0 0 1 0-5.959l4.413-4.468a1.547 1.547 0 0 1 2.207 0c.61.617.61 1.617 0 2.234l-4.413 4.469a1.063 1.063 0 0 0 0 1.49 1.031 1.031 0 0 0 1.47 0l6.613-6.696a3.72 3.72 0 0 0 .005-5.208 3.609 3.609 0 0 0-5.154-.005L7.95 13.052c-2.438 2.468-2.438 6.47 0 8.937a6.187 6.187 0 0 0 8.826 0l5.15-5.213a1.547 1.547 0 0 1 2.206 0c.609.617.609 1.617 0 2.234l-5.15 5.213a9.28 9.28 0 0 1-13.239 0c-3.656-3.701-3.656-9.703 0-13.405l7.715-7.813Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip28);
export default __webpack_public_path__ + "static/media/paperclip_28.b627d001.svg";
export { ForwardRef as ReactComponent };